/**
 * @generated SignedSource<<20bf2c1506f3cb0c9ce0dd79324b0156>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TabsCompanionMode_note$data = {
  readonly title: string;
  readonly url: string | null;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentType": "TabsCompanionMode_note";
};
export type TabsCompanionMode_note$key = {
  readonly " $data"?: TabsCompanionMode_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"TabsCompanionMode_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TabsCompanionMode_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "19b55a7eb5c63a05f18cb837e2fc9fa8";

export default node;
